import { Swiper, SwiperSlide } from "swiper/react";
import productImage from "../../../assets/images/Products/kpi4_original.png";
import AppConstants from "../../../common/AppConstants";
import { IProductInfo } from "../../../common/ViewModels";
import { A11y, Autoplay, Navigation, Pagination } from "swiper/modules";
import { useRef } from "react";

const ProductInfo = (props: IProductInfo) => {
  const swiperPricings = useRef(null);
  const handleMouseEnter = () => {
    if (swiperPricings && swiperPricings?.current)
      (swiperPricings?.current as any).swiper?.autoplay?.stop();
  };

  const handleMouseLeave = () => {
    if (swiperPricings && swiperPricings?.current)
      (swiperPricings?.current as any).swiper?.autoplay?.start();
  };
  return (
    <>
      <div className="banner product-details">
        <div className="overlay">
          <div
            className="container banner-content"
            style={{ position: "relative", zIndex: 2 }}
            data-aos="fade-up"
            data-aos-delay="10"
            data-aos-duration="600"
          >
            <div className="row align-items-center">
              <div
                className="col-lg-6 col-sm-12 left-prt"
                data-aos="slide-right"
                data-aos-delay="10"
              >
                <h1>{props.title}</h1>
                <p>
                  {props.primaryDescription}
                  <br />
                  <span
                    style={{ fontSize: "16px", marginTop: 0, display: "block" }}
                  >
                    {props.secondaryDescription}
                  </span>
                </p>
                <a
                  id="submit_btn3"
                  className="prod-btn btn-primary px-4"
                  href={
                    props.appsourceLink ||
                    "https://appsource.microsoft.com/en-us/marketplace/apps?search=cloudlas&page=1"
                  }
                  target="_blank"
                >
                  Go to Microsoft AppSource
                </a>
              </div>
              <div
                className="col-lg-6 col-sm-12 right-prt mb-4"
                data-aos="slide-left"
                data-aos-delay="10"
              >
                <div className="prod-imag">
                  <div className="one">
                    <img src={props.image} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="features">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-12">
              <h2>Attractive features</h2>
            </div>
            <div className="col-12 feature-points">
              <ul>
                {(props.features || []).map((item) => (
                  <>
                    <li data-aos="fade-up" data-aos-delay="10">
                      {/* <span>.</span> */}
                      {item}
                    </li>
                  </>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
      {props.youTubeLink && (
        <section className="features">
          <div className="container">
            <div className="row align-items-center text-center">
              <div className="col-12">
                <iframe
                  style={{ width: "100%", height: "400px" }}
                  src={props.youTubeLink}
                ></iframe>
              </div>
            </div>
          </div>
        </section>
      )}
      <section className="pricing">
        <div className="container">
          <div className="col-12 product-wrap text-center">
            {/* <h4>Best service at reasonable price</h4> */}
            <h2>Pricing</h2>
            <p>30 days trial, No contact or credit card required</p>
            <p>
              <a href="#/ContactUs">Please contact us for the pricing </a>
            </p>
          </div>
          <div className="row align-items-center text-center">
            <div className="col">
              <div
                className="price-wrap empDirectoryPricing owl-carousel"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                {/* {(props.pricings || []).length > 1 && (
                  <Swiper
                    ref={swiperPricings}
                    // install Swiper modules
                    modules={[Navigation, Pagination, A11y, Autoplay]}
                    spaceBetween={50}
                    slidesPerView={3}
                    freeMode={true}
                    allowTouchMove={false}
                    loop={true}
                    autoplay={{
                      delay: 0,
                      disableOnInteraction: true,
                    }}
                    speed={2000}
                    breakpoints={{
                      100: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                      },
                      1000: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                      },
                    }}
                  >
                    {(props.pricings || []).map((item) => {
                      return (
                        <>
                          {(props.pricings || []).length > 0 && (
                            <SwiperSlide>
                              <div className="price-item">
                                <a href={item.paymentLink} target="_blank">
                                  <div className="price-top price-lower">
                                    <h3>
                                      {item.userLimit == "Unlimited"
                                        ? ""
                                        : "Upto"}
                                      <span>{item.userLimit}</span> Users
                                    </h3>
                                    <h2>
                                      {item.price}
                                      <span>{item.priceText}</span>
                                    </h2>
                                    <p>{item.secondaryText}</p>
                                  </div>
                                </a>
                              </div>
                            </SwiperSlide>
                          )}
                        </>
                      );
                    })}
                  </Swiper>
                )} */}
                {/* {(props.pricings || []).length == 1 && (
                  <>
                    <div className="price-item">
                      <a href={props.pricings[0].paymentLink} target="_blank">
                        <div className="price-top price-lower">
                          <h3>
                            {props.pricings[0].userLimit == "Unlimited"
                              ? ""
                              : "Upto"}
                            <span>{props.pricings[0].userLimit}</span> Users
                          </h3>
                          <div className="priceContentArea">
                            {props.pricings[0].strikedPrice && (
                              <>
                                <s className="strikedPrice">
                                  {props.pricings[0].strikedPrice}
                                </s>
                                &nbsp;
                              </>
                            )}
                            <span className="priceSpan">
                              {props.pricings[0].price}
                            </span>
                            <span className="priceSubTextSpan">
                              {props.pricings[0].priceText}
                            </span>
                          </div>

                          <div className="priceOfferText">
                            {props.pricings[0].offerText || " "}
                          </div>

                          <p>{props.pricings[0].secondaryText}</p>
                        </div>
                      </a>
                    </div>
                  </>
                )} */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProductInfo;
